/* @flow */
import {some} from 'lodash';
import { locationAttrs } from './dom';

const DEV_SPOTIM_ID = 'sp_mTMt7GYC';
const HOSTNAME_WHITELIST = [
  /localhost/,
  /refinery29/,
  /29rooms/,
  /rf29/
];
const PRODUCTION_HOSTNAME_REG_EXP = /refinery29\.(com|uk|de)$/;
const LOCALHOST_HOSTNAME_REG_EXP = /localhost:\d{4}/;

const onWhitelistedHostname =
  (): bool =>
    some(
      HOSTNAME_WHITELIST,
      (hostname: string): ?Array<string> =>
        locationAttrs(window).hostname.match(hostname)
    );

export const renderingOnServer =
  (): bool =>
    typeof window === 'undefined';

export const onExternalSite =
  (): bool =>
    !renderingOnServer() && !onWhitelistedHostname();

export const onProduction =
  (): bool => process.env.NODE_ENV === 'production';

/*
 * Note: this is not meant to be a general purpose 'isProduction' function.
 *
 * For most use cases, the pattern we prefer is to check that NODE_ENV === 'production'.
 *
 * However, NODE_ENV is set to 'production' on devboxes, staging, and actual production.
 * So, for analytics and social beacons we just manually inspect the browser URL
 * (client-side) or the pageConfig hostname (server-side).
 *
 * Directions for use:
 *
 * On the client, call the function without params.
 * -> onProductionHostname()
 *
 * On the server, pass in the hostname.
 * -> onProductionHostname(pageConfig.hostname);
 */

export const onProductionHostname =
  (hostname: ?string): bool =>
    PRODUCTION_HOSTNAME_REG_EXP.test(hostname || window.location.hostname);


export const onLocalhostHostname =
  (hostname: ?string): bool =>
    LOCALHOST_HOSTNAME_REG_EXP.test(hostname || window.location.hostname);


export const envSpecificSpotID =
  (hostname: string, spotID: ?string): ?string => {
    /*
     * It is possible for spotim_id to be empty,
     * so in this case we want the same behavior on dev
     * as production (both are null).
     */
    if (!spotID) {
      return null;
    }

    return onProductionHostname(hostname)
      ? spotID
      : DEV_SPOTIM_ID;
  };
